// import { string } from "../../../helpers/converters";

export default {
  REBID_INFO(state) {
    return state.rebid_info
  },
};
